import { useSelector } from "react-redux";

function getInputFields() {
  return (rootState) => {
    return rootState.inputFields;
  };
}

export function useGetInputOptions() {
  const inputFields = useSelector(getInputFields());

  const inputFieldOptions = {};
  for (let eachInput in inputFields) {
    inputFieldOptions[eachInput] = inputFields[eachInput].value;
  }

  return inputFieldOptions;
}
